import {Component, Inject, OnInit, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/portal';

@Component({
  standalone: false,
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | ComponentType<any> | TemplateRef<any>) {
  }

  ngOnInit() {
  }

  isString(value: any) {
    return typeof value === 'string';
  }

}
